<template>
  <header :class="{ hide: hideHeader, scrolled }">
    <nav class="site-nav">
      <MainLogo />

      <div class="menu-mobile">
        <div
          v-if="isLoggedIn"
          class="user user-m"
          :style="{
            backgroundImage: `url(${profileImage.url})`,
          }"
          @click="onClickPofileImage"
        >
          <CoachMark
            v-if="showHeaderNicknameCoach && !hideHeader"
            direction="below"
            align="right"
            :offset="{ x: 40 }"
            :tail-offset="{ x:37 }"
            :text="$t('닉네임은프로필에서바꿀수있어요')"
            @close="dismissNicknameCoach"
          />
        </div>
        <a v-else class="login-m" @click="showLoginPopup" />
        <button id="burger" class="menu-m">
          <div type="button" class="burger">
            <span class="burger-line line-top" />
            <span class="burger-line line-bottom" />
          </div>
        </button>
      </div>

      <div id="menu" class="menu-container">
        <ul class="menu">
          <!-- 캠페인소개 -->
          <li class="menu-item menu-item-has-children">
            <span class="submenu-btn" />
            <NuxtLink :to="$localePath('/about')" @click="closeHeader">
              {{ $t('캠페인소개') }}
            </NuxtLink>
            <ul class="submenu">
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/about')" @click="closeHeader">
                  {{ $t('소개') }}
                </NuxtLink>
              </li>
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/status')" @click="closeHeader">
                  {{ $t('참여현황') }}
                </NuxtLink>
              </li>
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/video')" @click="closeHeader">
                  {{ $t('비디오뮤직') }}
                </NuxtLink>
              </li>
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/special/anniversary2nd')" @click="closeHeader">
                  {{ $t('1년의이야기') }}
                </NuxtLink>
              </li>
            </ul>
          </li>

          <!-- 참여하기 -->
          <li class="menu-item menu-item-has-children">
            <span class="submenu-btn" />
            <NuxtLink :to="$localePath('/checklist')" @click="closeHeader">
              {{ $t('참여하기') }}
            </NuxtLink>
            <ul class="submenu">
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/checklist')" @click="closeHeader">
                  {{ $t('데일리체크') }}
                </NuxtLink>
              </li>
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/peacemaker')" @click="closeHeader">
                  {{ $t('우리는피스메이커') }}
                </NuxtLink>
              </li>
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/signature')" @click="closeHeader">
                  {{ $t('지지서명') }}
                </NuxtLink>
              </li>
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/contest-familylove')" @click="closeHeader">
                  {{ $t('공모전') }}
                </NuxtLink>
              </li>
            </ul>
          </li>

          <!-- 다운로드 -->
          <li class="menu-item">
            <NuxtLink :to="$localePath('/download')" @click="closeHeader">
              {{ $t('다운로드') }}
            </NuxtLink>
          </li>

          <!-- 후기 -->
          <li class="menu-item">
            <NuxtLink :to="$localePath('/review')" @click="closeHeader">
              {{ $t('후기') }}
            </NuxtLink>
          </li>

          <!-- 뉴스 -->
          <li class="menu-item menu-item-has-children">
            <span class="submenu-btn" />
            <NuxtLink :to="$localePath('/news')" @click="closeHeader">
              {{ $t('뉴스') }}
            </NuxtLink>
            <ul class="submenu">
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/news')" @click="closeHeader">
                  {{ $t('주요소식') }}
                </NuxtLink>
              </li>
              <li class="submenu-item">
                <NuxtLink :to="$localePath('/press')" @click="closeHeader">
                  {{ $t('언론보도') }}
                </NuxtLink>
              </li>
            </ul>
          </li>

          <!-- language -->
          <li class="btn-lang" :class="{ open: langOpen }">
            <div class="lang-text" @click="langOpen = !langOpen">
              <span class="active">{{ serviceLang.find((lang) => lang.language_gb_sn === locale)?.language_native_nm }}</span>
            </div>
            <ul class="lang-list">
              <li v-for="lang in locales" :key="lang.code" :class="{ current: lang.code === locale }">
                <a @click="changeLocale(lang.code)">{{ lang.name }}</a>
              </li>
            </ul>
          </li>

          <li v-if="!isLoggedIn" class="menu-item login-pc" @click="showLoginPopup">
            <a class="btn-login">{{ $t('로그인') }}</a>
          </li>
          <li v-else class="menu-item user-pc" @click="onClickPofileImage">
            <div
              class="user pointer"
              :style="{
                backgroundImage: `url(${profileImage.url})`,
              }"
            />
            <CoachMark
              v-if="showHeaderNicknameCoach && !hideHeader"
              direction="below"
              align="right"
              :offset="{y:-10}"
              :text="`${$t('닉네임은프로필에서바꿀수있어요')}`"
              @close="dismissNicknameCoach"
            />
          </li>
          <!-- <li class="menu-item">
            <div v-if="jwtCookie === undefined" @click="showLoginPopup">로그인 안 됨</div>
            <div v-else @click="logout">{{ userNickName }}</div>
          </li> -->
          <!-- <ProfileSettingPopup /> -->
        </ul>
      </div>
    </nav>
    <div class="overlay" @click="closeHeader" />
  </header>
</template>

<script lang="ts" setup>
const { fetchServiceLanguages } = useLanguages()
const { locale, locales } = useI18n()
const switchLocalePath = useSwitchLocalePath()

const { showLoginPopup, isLoggedIn, profileImage } = useAuth()
const { showProfilePopup } = useProfile()
const { showHeaderNicknameCoach, dismissNicknameCoach } = useCoachMark()

const serviceLang = await fetchServiceLanguages()

const bodyClass = ref('')
useHead({
  bodyAttrs: {
    class: bodyClass,
  },
})

// Header Scroll
const prevScroll = ref<number | null>(null)
const hideHeader = ref(false)
const scrolled = ref(false)
const langOpen = ref(false)

onMounted(() => {
  scrolled.value = window.scrollY !== 0
  window.addEventListener('scroll', onScroll)
})
onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})

function onScroll(_: Event) {
  if (window.scrollY < 100) {
    hideHeader.value = false
  }
  else if (prevScroll.value !== null) {
    if (window.scrollY > prevScroll.value) {
      hideHeader.value = true
    }
    else {
      hideHeader.value = false
    }
  }
  prevScroll.value = window.scrollY
  scrolled.value = window.scrollY !== 0
}

function changeLocale(languageGbSn: any) {
  langOpen.value = false
  closeHeader()
  const path = switchLocalePath(languageGbSn)
  navigateTo(path)
}

function closeHeader() {
  const burger = document.getElementById('burger') as HTMLButtonElement
  const menu = document.getElementById('menu') as HTMLDivElement
  const header = document.querySelector('header') as HTMLElement

  menu.classList.remove('show') // 메뉴 닫힘
  burger.classList.remove('open') // 햄버거 애니메이션
  header.classList.remove('header-on') // header-on 클래스 토글
  bodyClass.value = ''
}

function openHeader() {
  const burger = document.getElementById('burger') as HTMLButtonElement
  const menu = document.getElementById('menu') as HTMLDivElement
  const header = document.querySelector('header') as HTMLElement

  menu.classList.add('show') // 메뉴 열림
  burger.classList.add('open') // 햄버거 애니메이션
  header.classList.add('header-on') // header-on 클래스 토글
  bodyClass.value = 'lock'
}

onMounted(() => {
  const burger = document.getElementById('burger') as HTMLButtonElement
  const menu = document.getElementById('menu') as HTMLDivElement

  burger.addEventListener('click', () => {
    if (menu.classList.contains('show')) {
      closeHeader()
    }
    else {
      openHeader()
    }
  })

  // 모든 submenu 버튼과 해당 서브메뉴 요소 선택
  const submenuBtns = document.querySelectorAll('.submenu-btn') as NodeListOf<HTMLSpanElement>

  submenuBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      this.classList.toggle('on') // submenu에 'on' 클래스 토글
      const menuItem = btn.closest('.menu-item') as HTMLElement
      const submenu = menuItem.querySelector('.submenu') as HTMLElement
      submenu.classList.toggle('on') // submenu에 'on' 클래스 토글
    })
  })
})

function onClickPofileImage(event: any) {
  const element = event.target as HTMLElement
  const rect = element.getBoundingClientRect()

  // 현재 스크롤 위치를 가져옵니다.
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop

  // 문서 기준 요소의 절대 좌표를 계산합니다.
  const elementAbsoluteX = rect.left + scrollLeft
  const elementAbsoluteY = rect.top + scrollTop

  showProfilePopup(elementAbsoluteX, elementAbsoluteY)

  // scroll to top
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
</script>

<style scoped>
.user-pc {
  position: relative;
}

.user-m {
  position: relative;
}
</style>
